module.exports = "{{ 'periodic_tasks.repeater_configurator.at_the_following_days' | translate }}:\n{{ TaskDetailsCtrl.taskDetails.repeater_config | daysOfWeekDisplay }}\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/app/components/periodic_tasks/task_details/display_days_of_week.html
// module id = 746
// module chunks = 0